const isMissingCoordinate = (value) =>
  value === null || value === undefined || (typeof value === 'string' && value.trim() === '');

const isFiniteCoordinate = (value) => {
  if (isMissingCoordinate(value)) return false;
  return Number.isFinite(Number(value));
};

/**
 * Проверяет, содержит ли объект координаты в корректном формате.
 *
 * Координаты считаются валидными, если:
 * - поле `position` существует и является массивом длины 2;
 * - значения координат не пустые (`null`, `undefined`, '' не допускаются);
 * - обе координаты приводятся к конечному числу.
 *
 * @param {Object} marker - Объект, содержащий поле `position` — массив с координатами [lat, lon].
 * @returns {boolean} true — если координаты валидны, иначе false.
 */
export const isValidMarker = (marker) => {
  if (!marker || !Array.isArray(marker.position) || marker.position.length !== 2) return false;

  const [lat, lon] = marker.position;

  return isFiniteCoordinate(lat) && isFiniteCoordinate(lon);
};

/**
 * Фильтрует массив маркеров, оставляя только те, у которых валидные координаты.
 *
 * @param {Array<Object>} markers - Массив объектов, содержащих поле `position`.
 * @returns {Array<Object>} Только валидные маркеры.
 */
export const getValidMarkers = (markers = []) => {
  return Array.isArray(markers) ? markers.filter(isValidMarker) : [];
};
